import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

// Build full text from prebody/body/postbody supporting both plain objects and Immutable.js Maps
export const buildTextFromMessageValue = (value: any): string => {
    const get = (k: string) => (value?.get ? value.get(k) : value?.[k])
    return [get("prebody"), get("body"), get("postbody")].filter(Boolean).join("\n\n")
}

// Attach original_template_text and (optionally) variation_id based on feature flag and caller policy
// allowVariation: when false, variation_id will not be attached even if available (e.g., White House/Regulations)
// defaultTemplateGetter/variationIdGetter: side-effect-free getters for the source-specific data
export const attachOriginals = (
    gsaInfo: any,
    options: {
        allowVariation: boolean
        defaultTemplateGetter: () => any
        variationIdGetter?: () => any
    },
): void => {
    try {
        if (!isFeatureEnabled("ff_grassroots_edited_content_filter")) return

        const def = options.defaultTemplateGetter?.()
        if (def) {
            gsaInfo["original_template_text"] = def
        }

        if (options.allowVariation && options.variationIdGetter) {
            const vid = options.variationIdGetter()
            if (vid) gsaInfo["message_variation_id"] = vid
        }
    } catch (_) {
        // no-op: helpers must be resilient
    }
}

// Return edited-content fields (original_template_text and optionally message_variation_id)
// based on ff_grassroots_edited_content_filter. Safe no-throw helper.
export const editedContentFields = (message: any, allowVariation: boolean) => {
    try {
        if (!isFeatureEnabled("ff_grassroots_edited_content_filter")) return {}
        // Prefer immutable original if present; otherwise fallback to current raw snapshot
        const pre = message?.original_prebody ?? message?.raw?.preBody ?? ""
        const body = message?.original_body ?? message?.raw?.content ?? ""
        const post = message?.original_postbody ?? message?.raw?.postBody ?? ""
        const originalFromFields = [pre, body, post].filter(Boolean).join("\n\n")
        const original = message?.original_template_text ?? originalFromFields

        const out: any = {}
        if (original) out.original_template_text = original

        if (allowVariation) {
            const vid = message?.raw?.variation_id ?? message?.variation_id ?? null
            if (vid) out.message_variation_id = vid
        }
        return out
    } catch (_) {
        return {}
    }
}
